// Usamos un eventListener para seleccionar que cuando el Dom se descargue, inicie en iniciarApp()
document.addEventListener('DOMContentLoaded', function() { 
    iniciarApp();
});

window.addEventListener('load', function(){
  carga();
});

let tempItemsSearch = [];

let tempCategories = {};

document.body.addEventListener("keydown", function(event) {
  // Atras
  if (event.code === 'ArrowLeft' || event.keyCode === 37){
    $('.btn-anterior').click();
  }
  // Siguiente
  if (event.code === 'ArrowRight' || event.keyCode === 39){
    $('.btn-siguiente').click();
  }
});

function iniciarApp(){
  searchItems();
  tableIndexAdmin();
  esconderHijos();
  navResponsive();
  headerAnimado();
  generarColores();
  generarCategorias();
  generarContacto();
  dibujarIndexPrincipal();
  anioCopyright();
  sidebar();
  formularios();
  limitarTextArea();
  // eliminarImagen();
  volverEnviarCodigo();
  mostrarClave();
  comprobarQueCoincidan();
  cambiarIndex();
  mostrarOcultarHijos();
  generateSelects();
  generateSelectsActFirst();
  generateSelectsAct();
  mostrarOcultarImagenNuevo();
  generateCategoriesImages();
  moveItems();
  moveColors();
  moveCurrentImages();
  mouseScroll();
}

function carga() {
  setTimeout(function(){
    $('.loading').fadeOut(1000);
  }, 1000);
}

function navResponsive(){
  const btn = $('.btn-menu');
  const menu = $('nav');
  const links = $('nav a');
  const btnX = $('.btn-menu-x');

  btn.on('click', function(){
    menu.toggleClass('mostrar');

    btnX.on('click', function(){
      menu.removeClass('mostrar');
    });

    links.on('click', function(){
      menu.removeClass('mostrar');
    });
  });
}

function headerAnimado(){
  // $(window).scroll(function() {
  //   const window = $(this);

  //   if (window.scrollTop() > 0) {
  //     $('.header-contenido img').css("width", "13rem")
  //   } else {
  //     $('.header-contenido img').css("width", "20rem")
  //   }
  // });
}

function modalCatalogo(){
  let btn = $('.item');

  btn.on('click', function(e){
    e.preventDefault();

    let thisBtn = $(this);
    let id = thisBtn.attr('id');
    let items = getItemsActivos();
    let item = items.find(ite => ite.id === id);

    dibujarModal(item);
  });
}

function anioCopyright(){
  const anio = (new Date).getFullYear();
	$(document).ready(function() {
	  	$("#año").text( anio );
	});
}

function sidebar(){
  const boton = $('.btn-sidebar');
  const sidebar = $('.sidebar');
  const admin = $('.admin-contenido');

  boton.on('click', function(){
    sidebar.toggleClass('cerrado');
    admin.toggleClass('admin-abierto');
    $('.dash-contenido').toggleClass('admin-abierto');
  });
}

function formularios(){
  let productos = 'producto';
  let colores = 'color';
  let categoria = 'categoria';

  formAgregar(productos);
  formAgregar(colores);
  formAgregar(categoria);
  formActualizar();
}

function formAgregar(nombre){
  const btn = $('.nuevo-'+nombre+'');
  const btnX = $('.form-agregar-'+nombre+' .btn-x');
  btn.on('click', function(){
    $('.form-agregar-'+nombre+'').fadeIn();
    $('.form-agregar-'+nombre+'').css("display", "flex");

    btnX.on('click', function(){
      $('.form-agregar-'+nombre+'').fadeOut();
      $('.form-agregar-'+nombre+'').css("display", "none");
    });
  });
}

function formActualizar() {
  const btnClick = $('.actualizar');
  let page = window.location.href;

  if (btnClick.hasClass('cat-hija')) {
    // generateModalUpdateCatChild(btnClick.id);
  } else {
    btnClick.on('click', function () {
      const btn = $(this);
      const form = btn.next();
      const btnX = form.find('.btn-x');

      form.fadeIn();
      form.css("display", "flex");

      page.includes('admin/index.php') ? $('.table tbody').sortable("disable") : '';
      page.includes('admin/colores.php') ? $('.cont-admin-colors').sortable("disable") : '';

      btnX.on('click', function (e) {
        e.preventDefault();
        form.fadeOut();
        form.css("display", "none");

        page.includes('admin/index.php') ? $('.table tbody').sortable("enable") : '';
        page.includes('admin/colores.php') ? $('.cont-admin-colors').sortable("enable") : '';
      });
    });
  }
}

function limitarTextArea() {
  let textarea = $('textarea');
  let mensaje = textarea.next();
  mensaje.css("font-size", "14px");
  mensaje.text('150 caracteres restantes');
  let max = 150;

  textarea.keyup(function() { 
    let len = $(this).val().length;

    if(len >= max) {
      mensaje.css("color", "red");
      mensaje.text('Ha llegado al limite de caracteres');
    } else {
      let cr = max - len;
      mensaje.css("color", "black");
      mensaje.text(cr + ' caracteres restantes');         
    }
  });
}

$('.actualizar').on('click', function(){
  const btn = $(this);
  const form = btn.next();
  const btnX = form.find('.btn-x');

  form.fadeIn();
  form.css("display", "flex");

  btnX.on('click', function(e){
    e.preventDefault();
    form.fadeOut();
    form.css("display", "none");
  });

  generateSelectsActFirst();
  generateSelectsAct();
});

$('.eliminar').on('click', function(){
  const btn = $(this);
  const form = btn.next();
  const btnX = form.find('.btn-x');
  const btnNo = form.find('.btn-eli-no');

  form.fadeIn();
  form.css("display", "flex");

  btnX.on('click', function(e){
    e.preventDefault();
    form.fadeOut();
    form.css("display", "none");
  });

  btnNo.on('click', function(e){
    e.preventDefault();
    form.fadeOut();
    form.css("display", "none");
  });
});

function volverEnviarCodigo(){
  var cont = $('.volver-enviar');
  var counter = 60;
  var btn = $('.btn-volver-enviar');

  var id = setInterval(function(){ 
    if(counter==0) {
        $('#contador').remove();
        clearInterval(id);
        cont.append('<a class="btn-volver-enviar" href="volver-enviar.php">Volver a enviar</a>');
    }
    else
    {
        counter=counter-1; 
        $('#contador').text( counter + 's' ); 
    }
  }, 1000);
}

function mostrarClave(){
  const conte = $('.mostrar-pass');
  const check = conte.find('input');
  
  check.on('click', function(){
    let checkSeleccionado = $(this);
    let input = checkSeleccionado.parent().prev();

    if($(this).is(':checked')){
      input.attr('type', 'text')
    } else {
      input.attr('type', 'password');
    }
  });
}

function comprobarQueCoincidan(){
  let inputs = $('.inputs-clave');
  let enviar = $('#btn-rest-pass');

  inputs.keyup(function(){
    let input = $('#passuno').val();
    let inputdos = $('#passdos').val();

      if(input === inputdos){

        enviar.prop("disabled", false)
        inputs.css("border", "1px solid green");

      } else {
        enviar.prop("disabled", true)
        inputs.css("border", "1px solid red");
      }
  });
}

// function eliminarImagen(){
  let btn = $('.btn-eliminar-imagen');

  btn.on('click', function(e){
    e.preventDefault();
    let button = $(this);
    let id = $(this).attr('id');

    $.ajax({
      method: "POST",
      url: "../admin/eliminar-imagen.php",
      data: { id: id }
    })
      .done(function( response ) {
        button.parent().fadeOut(1000);
      });
  });
// }

function cambiarIndex(){
  let btn = $('.btn-index');

  btn.on('click', async function(){
    let button = $(this);
    let id = button.attr('id');
    let array = id.split('-');

    let direccion = array[0];
    id = array[1];
    let original = {};
    let reemplazo = {};
    let items = [];

    await $.ajax({
      method: "POST",
      url: "../admin/obtener-colores.php",
      data: {
         id: id,
         direccion: direccion 
      }
    })
    .done(function( response ) {
      items = JSON.parse(response);
    });

    original = items.find(item => item.id === id);

    if(direccion === "abajo"){
      reemplazo = items.find(item => parseInt(item.indice) - 1 === parseInt(original.indice));
    } else {
      reemplazo = items.find(item => parseInt(item.indice) + 1 === parseInt(original.indice));
    }

    if(reemplazo != undefined){
      await $.ajax({
        method: "POST",
        url: "../admin/cambiar-index.php",
        data: {
          idOriginal: parseInt(original.id), 
          idReemplazo : parseInt(reemplazo.id),
          indiceOriginal: parseInt(original.indice),
          indiceReemplazo: parseInt(reemplazo.indice)
        }
      })
      .done(function( response ) {
        window.location.reload();
      });
    }
  });
}

$('.btn-index-item').on('click', async function(){
  let button = $(this);
  let id = button.attr('id');
  let array = id.split('-');

  let direccion = array[0];
  id = array[1];

  await $.ajax({
    method: "POST",
    url: "../admin/cambiar-index-item.php",
    data: {
      id: id, 
      direccion : direccion
    }
  })
  .done(function( response ) {
    if(response === "1"){
      window.location.reload();
    }
  });
});


$('.btn-index-imagen').on('click', async function(){
  let button = $(this);
  let id = button.attr('id');
  let array = id.split('-');
  let parent = button.parent().parent().attr('id');

  let arrayParent = parent.split('-');

  let idParent = arrayParent[2];

  let direccion = array[0];
  let indice = array[2];
  id = array[1];

  await $.ajax({
    method: "POST",
    url: "../admin/cambiar-index-imagenes.php",
    data: {
        id: id,
        direccion: direccion,
        indice: indice,
        idItem: idParent
    }
  })
  .done(function( response ) {
    if(response === "1"){
      redibujarImagenes(parent);
    }
  });
});


async function dibujarIndexPrincipal() {
  let firstTrigger = false;
  let items;
  let arrayOrdenado = [];
  let contenedor = $('.catalogo-items');
  await $.ajax({
    url: "../admin/obtener-todos-items.php",
  })
    .done(function (response) {
      items = JSON.parse(response);
    });

  items.forEach(item => {
    let itemInArray = arrayOrdenado.find(it => it.id === item.idProducto);

    if (itemInArray === undefined) {
      arrayOrdenado.push({
        "id": item.idProducto,
        "nombre": item.nombre,
        "subtitulo_1": item.subtitulo_1,
        "subtitulo_2": item.subtitulo_2,
        "descripcion": item.descripcion,
        "indice": item.indice,
        "idColor": item.idColor,
        "indiceColor": item.indiceCol,
        "imagenes": [{
          "nombre": item.nombreImagen,
          "id": item.id,
          "indice": item.indiceImg
        }],
        "idCategoria": parseInt(item.id_categoria),
        "idCategoriaPadre": parseInt(item.id_categoria_padre),
      });
    } else {
      itemInArray.imagenes.push({
        "nombre": item.nombreImagen,
        "id": item.id,
        "indice": item.indiceImg
      });
    }
  });

  setItemsActivos(arrayOrdenado);

  function aplicarFiltros() {
    let filtroCategoria = $('.categoria.active').attr('id') || 'todos';
    let filtroCategoriaPadre = $('.categoria-padre.active').attr('id') || 'todos';
    let filtroColor = $('.color.active').attr('id');

    if(!filtroColor){
      filtroColor = 'todos';
    }

    if(!filtroCategoria){
      filtroCategoria = 'todos';
    }

    comprobarColor(filtroColor);

    let filtrados = arrayOrdenado.filter(item => {
      let cumpleCategoria;
      let cumpleColor;
      if(filtroCategoriaPadre || filtroCategoria){
        if(JSON.parse(sessionStorage.getItem('categoria-activa'))){
          let categorieActive = JSON.parse(sessionStorage.getItem('categoria-activa'));

          if(!firstTrigger){
            setTriggerCategorys(categorieActive);
            firstTrigger = true;
          }

          cumpleCategoria = parseInt(categorieActive) === parseInt(item.idCategoriaPadre);
        } else if(filtroCategoriaPadre !== 'todos' && filtroCategoria === 'todos'){
          cumpleCategoria = filtroCategoriaPadre === `categoria-${item.idCategoriaPadre}`;
        } else {
          cumpleCategoria = filtroCategoria === 'todos' || `categoria-${item.idCategoria}` === filtroCategoria;
        }
      }

      if(filtroColor){
        cumpleColor = filtroColor === 'todos' || `color-${item.idColor}` === filtroColor;
      }

      return cumpleCategoria && cumpleColor;
    });

    sessionStorage.removeItem('categoria-activa');

    // vaciarContenedor(contenedor);
    contenedor.fadeOut(0, function(){
      contenedor.empty();
      filtrados.forEach(item => {
        contenedor.append(dibujarTemplate(item));
      });

      if(filtrados.length){
        setItemsActivos(filtrados);
      }

      modalCatalogo();
      contenedor.fadeIn(600);
    });

    $('body, html').animate({ scrollTop: 0 }, 200);
  }

  $('.color').on('click', function () {
    $('.color').removeClass('active');
    $(this).addClass('active');
    aplicarFiltros();
  });

  if($(window).width() <= 768){
    $('.categoria-padre > p').on('touchstart', function () {
      $('.categoria').removeClass('active');
      $('.categoria-padre').removeClass('active');
      $(this).parent().addClass('active');
      aplicarFiltros();
    });
  
    $('.categoria').on('touchstart', function () {
      $('.categoria').removeClass('active');
      if($(this).attr('id') === 'todos'){
        $('.categoria-padre').removeClass('active');
      }
      // $('.sub-categorias-cont').fadeOut(50);
      $(this).addClass('active');
      $('.categoria-padre').removeClass('active');
      $(this).parent().parent().addClass('active');
      aplicarFiltros();
    });
  } else {
    $('.categoria-padre > p').on('click', function () {
      $('.categoria').removeClass('active');
      $('.categoria-padre').removeClass('active');
      $(this).parent().addClass('active');
      aplicarFiltros();
    });
  
    $('.categoria').on('click', function () {
      $('.categoria').removeClass('active');
      if($(this).attr('id') === 'todos'){
        $('.categoria-padre').removeClass('active');
      }
      // $('.sub-categorias-cont').fadeOut(50);
      $(this).addClass('active');
      $('.categoria-padre').removeClass('active');
      $(this).parent().parent().addClass('active');
      aplicarFiltros();
    });
  }

  // $('.categoria-padre > p').on('click touchstart', function () {
  //   $('.categoria').removeClass('active');
  //   $('.categoria-padre').removeClass('active');
  //   $(this).parent().addClass('active');
  //   aplicarFiltros();
  // });

  // $('.categoria').on('click touchstart', function () {
  //   $('.categoria').removeClass('active');
  //   if($(this).attr('id') === 'todos'){
  //     $('.categoria-padre').removeClass('active');
  //   }
  //   // $('.sub-categorias-cont').fadeOut(50);
  //   $(this).addClass('active');
  //   $('.categoria-padre').removeClass('active');
  //   $(this).parent().parent().addClass('active');
  //   aplicarFiltros();
  // });

  aplicarFiltros();
}

function comprobarColor(color){
  if(color === 'todos'){
    $('.quitar-colores').fadeOut(0);
  } else {
    $('.quitar-colores').fadeIn(400);
  }
}

function dibujarTemplate(obj){
  let htmlText = '';

  if(obj.subtitulo_1){
    htmlText += `<p class="subtitulo_1">${obj.subtitulo_1}</p>`;
  }

  if(obj.subtitulo_2){
    htmlText += `<p class="subtitulo_2">${obj.subtitulo_2}</p>`;
  }

  let html = 
  `
  <a id="${obj.id}" class="item">
      <div class="imagen">
          <img class="img-for-item" loading="lazy" src="admin/upload/${obj.imagenes[0].nombre}" alt="alfombra">

          <img class="flot-im-item" src="../build/img/circ-item.png" alt="logo">
      </div>
      <div class="texto">
          <h2>${obj.nombre}</h2>
          ${htmlText}
      </div>
  </a> <!-- .item -->
  `;

  return html;
}

async function generarColores(){
  let colores;
  let contenedor = $('.flotante-colores');
  let html = ``;

  await $.ajax({
    url: "../admin/obtener-colores.php",
  })
  .done(function( response ) {
    colores = JSON.parse(response);
  });

  for(let i = 0; i < colores.length; i++){
    html += 
    `
      <div title="${colores[i].nombre}" id="color-${colores[i].id}" class="color" style="background-color: #${colores[i].codigo}"></div>
    `;
  }

  contenedor.prepend(html);
}

async function generarCategorias(){
  let categorias;
  let contenedor = $('#categorias');
  let page = window.location.href;

  await $.ajax({
    url: "../admin/obtener-categorias.php",
  })
  .done(function( response ) {
    categorias = JSON.parse(response);
  });

  categorias.forEach(categoria => {
    let htmlChilds = `<div class="sub-categorias-cont">`;

    let htmlCondition = '';

    if(!page.includes('catalogo')){
      htmlCondition = ` onclick="changeDisplay(${categoria.id})"`;
    }

    categoria.childs.forEach(subCat => {
      let htmlTempCondition = '';

      if(!page.includes('catalogo')){
        htmlTempCondition = ` onclick="changeDisplay(${subCat.id})"`;
      }

      htmlChilds += `<div ${htmlTempCondition} id="categoria-${subCat.id}" class="categoria"><p>${subCat.nombre}</p></div>`
    })

    htmlChilds += `</div>`;

    html = 
    `
      <div ${htmlCondition} id="categoria-${categoria.id}" class="categoria-padre"><p>${categoria.nombre}</p> ${htmlChilds}</div>
    `;

    // contenedor.append(html);
    $('.categorias-comunes').append(html);
    $('.categorias-mob').append(html);
  });
  esconderCategorias();
  animacionCategorias();
  hoverCategorias();
}

async function generarContacto(){
  await $.ajax({
    url: "../admin/obtener-contacto.php",
  })
  .done(function( response ) {
    JSON.parse(response).forEach(cont => {
      let {
        tel1,
        tel2,
        ubicacion_texto,
        ubicacion_link,
        instagram_texto,
        instagram_link,
        horario
      } = cont;

      $('#tel1').text(tel1);
      $('#tel2').text(tel2);
      $('#ubicacion').text(ubicacion_texto);
      $('#ubicacion').parent().attr('href', ubicacion_link);
      $('#instagram').text(instagram_texto);
      $('#instagram').parent().attr('href', instagram_link);
      $('#horario').text(horario);
    });
  });
}

function vaciarContenedor(contenedor){
  contenedor.fadeOut(0);
  contenedor.empty();
}

function setItemsActivos(array){
  return sessionStorage.setItem('items', JSON.stringify(array));
}

function getItemsActivos(){
  return JSON.parse(sessionStorage.getItem('items'));
}

function sliderModal(){
  // $('.slider-imagenes').fadeIn(200);
  // $('.slider-imagenes').slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true
  // });
  
  // setArrows();
}

function setArrows(){
  $('.slick-prev').empty();
  $('.slick-next').empty();
  $('.slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" class="arrows icon icon-tabler icon-tabler-arrow-bar-to-left" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="10" y1="12" x2="20" y2="12" /><line x1="10" y1="12" x2="14" y2="16" /><line x1="10" y1="12" x2="14" y2="8" /><line x1="4" y1="4" x2="4" y2="20" /></svg>');
  $('.slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" class="arrows icon icon-tabler icon-tabler-arrow-bar-to-right" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="14" y1="12" x2="4" y2="12" /><line x1="14" y1="12" x2="10" y2="16" /><line x1="14" y1="12" x2="10" y2="8" /><line x1="20" y1="4" x2="20" y2="20" /></svg>');
}

function dibujarModal(item){
  $('.modal').remove();
  let condition = "";
  
  if(item.imagenes.length === 1){
    condition = "onlyImg";
  }
    let htmlImages = "";

    let indexImages = 1;

    let htmlText = "";

    let htmlArrows = "";

    if(condition !== "onlyImg"){
      htmlArrows = `
        <div class="controls-2">
          <button class="btn-anterior disabled" onclick="triggerChange('prev')">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 42 42" fill="none">
              <path d="M19.344 21L27.394 12.95L25.55 11.106L15.6559 21L25.55 30.8941L27.394 29.05L19.344 21Z" fill="white"/>
            </svg>
          </button>       
          <button class="btn-siguiente" onclick="triggerChange('next')">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 42 42" fill="none">
              <path d="M22.656 21L14.606 12.95L16.45 11.106L26.3441 21L16.45 30.8941L14.606 29.05L22.656 21Z" fill="white"/>
            </svg>
          </button>
        </div>
      `;
    }

    if(item.subtitulo_1){
      htmlText += `<p class="subtitulo_1">${item.subtitulo_1}</p>`;
    }

    if(item.subtitulo_2){
      htmlText += `<p class="subtitulo_2">${item.subtitulo_2}</p>`;
    }

    if(item.descripcion){
      htmlText += `<p class="descripcion">${item.descripcion}</p>`;
    }

    if(condition !== "onlyImg"){
      item.imagenes.forEach(imagen => {
        htmlImages += `
        <div class="imagen">
          <img class="flot-im-item" src="../build/img/circ-item.png" alt="logo">
          <img class="imagen-slider" src="../../admin/upload/${imagen.nombre}" onclick="changeDinamicImageModalIndex('${imagen.nombre}', ${indexImages})" alt="Imagen slider">
        </div>
        `;
  
        indexImages++;
      });
    }

    let html;

    html = `<div class="modal" id="indice-${item.id}">
              <div class="modal-contenido">
                  <div class="contenido">
                      <button class="btn-x">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M18 6l-12 12"></path>
                          <path d="M6 6l12 12"></path>
                        </svg>
                      </button>
                      
                      <div class="loadingImagenes show">
                        <div class="spin"></div>
                      </div>

                      <div class="slider-imagenes slider-${item.id}">${htmlImages}</div>

                      <div class="central-imagen ${condition}">
                        <p class="flot-index">
                          1/${item.imagenes.length}
                        </p>
                        <img class="flot-im-item" src="../build/img/circ-item.png" alt="logo">
                        <img class="img-for-item" onclick="openModalFullScreen()" src="../../admin/upload/${item.imagenes[0].nombre}" alt="alfombra">

                        ${htmlArrows}
                      </div>
                      
                      <div class="texto">
                        <h2>${item.nombre}</h2>
                        ${htmlText}
                      </div>

                  </div>
              </div>
          </div>`
    
    $('body').append(html);
    $('.slider-imagenes').fadeOut(0);
    $('.central-imagen').fadeOut(0);
    $('.modal').fadeIn();
    $('.modal').css("display", "flex");
    $('body').addClass('fijo');
    $('html').addClass('fijo');

    let imagenesParaCargar = $('.slider-' + item.id + ' img');
    let arrayImg = Array.from(imagenesParaCargar);

    let imagenCentral = $('.central-imagen img');
    let arrayImgCentral = Array.from(imagenCentral);

    arrayImg.push(arrayImgCentral[0]);

    let count = arrayImg.length;

    if(arrayImg.length > 2){
      // logica para slider y carga
      arrayImg.forEach(img =>{

        img.onload = function(){
          count--;
  
          if(count === 0){
            $('.loadingImagenes').fadeOut(0);
            $('.slider-imagenes').fadeIn(200);
            $('.central-imagen').fadeIn(200);
          }
        };
      }) 
    } else {
      $('.loadingImagenes').fadeOut(0);
      // $('.slider-imagenes').fadeIn(200);
      $('.central-imagen').fadeIn(200);
    }
    
    $('.btn-x').on('click', function(){
      let modal = $('.modal');

      modal.fadeOut();

      setTimeout(function(){
        modal.remove();
      }, 1000);

      $('body').removeClass('fijo');
      $('html').removeClass('fijo');
    })

    atrasSiguiente();
}

function atrasSiguiente(){
  let btns = $('.pasar-alfombras');
  
  btns.on('click', function(){
    let direccion = $(this).attr('id');
    let items = getItemsActivos();
    let indiceActual = $(this).parent().attr('id');
    if(indiceActual === undefined){
      indiceActual = $(this).parent().parent().attr('id')
    }
    indiceActual = indiceActual.split('-');
    idItem = indiceActual[1]; 

    if(direccion === "atras"){
      let found = false;
      let temp = null;

      for(let i = 0; i < items.length; i++){
        if(parseInt(items[i].id) === parseInt(idItem)){
          found = true;
        } else {
          if(found === false){
            temp = items[i];
          }
        }
      }
      
      if(temp){
        dibujarModal(temp);
      } else {
        dibujarModal(items[items.length - 1]);
      }
    } else {
      let found = false;
      let temp = null;
      const newArray = items.reverse();

      for(let i = 0; i < newArray.length; i++){
        if(parseInt(newArray[i].id) === parseInt(idItem)){
          found = true;
        } else {
          if(found === false){
            temp = newArray[i];
          }
        }
      }
      
      if(temp){
        dibujarModal(temp);
      } else {
        dibujarModal(items[items.length - 1]);
      }
    }
  });
}

function esconderHijos(){
  $('.cat-hijas').slideUp(0);
}

function mostrarOcultarHijos(){
  $('.show-childs').on('click', function(){

    let btn = $(this);
    let id = btn.attr('id');
    let numero = id.substring(9)

    $('#cont-' + numero).slideToggle(200);
  });
}

async function generateSelects(){
  const option = $('.select-categoria-nueva option:selected');
  const id = option.val();
  
  if(id){
    await $.ajax({
      url: "../admin/obtener-sub-categorias.php?id=" + id,
    })
    .done(function( response ) {
      const data = JSON.parse(response);
      $('.select-child-nueva').empty();
      let html = `<option value=NULL>Sin sub categoria</option>`;
      
      if(data.length){
        data.forEach(subCat => {
          html += `<option value="${subCat.id}">${subCat.nombre}</option>`;
        });
      }
  
      $('.select-child-nueva').append(html);
    });
  }
}

function generateSelectsActFirst(){
  $('.select-categoria-padre-act').each(function(){
    const option = $(this).find('option:selected');
    const id = option.val();
    const firstValue = $(this).next().val();
    const nextSelect = $(this).parent().next().find("select");
    
    $.ajax({
      url: "../admin/obtener-sub-categorias.php?id=" + id,
    })
    .done(function( response ) {
      const data = JSON.parse(response);
      nextSelect.empty();
      let html = `<option value=NULL>Sin sub categoria</option>`;
      
      if(data.length){
        data.forEach(subCat => {
          let selected = "";

          if(parseInt(firstValue) === parseInt(subCat.id)){
            selected = "selected";
          }

          html += `<option value="${subCat.id}" ${selected}>${subCat.nombre}</option>`;
        });
      }

      nextSelect.append(html);
    });
  });
}

function generateSelectsAct(){
  $('.select-categoria-padre-act').change(function(){
    const option = $(this).find('option:selected');
    const id = option.val();
    const nextSelect = $(this).parent().next().find("select");

    $.ajax({
      url: "../admin/obtener-sub-categorias.php?id=" + id,
    })
    .done(function( response ) {
      const data = JSON.parse(response);

      nextSelect.empty();
      let html = `<option value=NULL>Sin sub categoria</option>`;
      
      if(data.length){
        data.forEach(subCat => {
          html += `<option value="${subCat.id}">${subCat.nombre}</option>`;
        });
      }

      nextSelect.append(html);
    });
  })
}

function esconderCategorias(){
  $('.sub-categorias-cont').fadeOut(0);
}

function hoverCategorias(){
  let page = window.location.href;
  if(!page.includes("catalogo")){
    return;
  }
  $('.categoria-padre').on('mouseover',function(){
    const temp = $(this);
    let cont = $(this).find('.sub-categorias-cont');

    cont.fadeIn(100);

    temp.on('mouseleave', function(){
      cont.fadeOut(0);
    })
  });
}

function animacionCategorias(){
  $('.categoria-padre > p').on('click', function(){
    $('.categoria-padre').removeClass('active');
    $(this).parent().addClass('active');
  });
}

function mostrarOcultarImagenNuevo(){
  $('.categoria-padre-nuevo').change(function(){
    const option = $(this).find('option:selected');
    const id = option.val();

    if(id !== "null"){
      $('.campo-imagen-nuevo').fadeOut(0);
    } else {
      $('.campo-imagen-nuevo').fadeIn(200);
    }
  })
}

function generateCategoriesImages(){
  $.ajax({
    url: "../admin/obtener-categorias.php",
  })
  .done(function( response ) {
    const data = JSON.parse(response);

    let html = "";
    
    if(data.length){
      data.forEach(subCat => {
        const {
          id,
          nombre,
          nombreImagen
        } = subCat;

        html += `
        <div onclick="changeDisplay('${id}')" class="item-categoria">
          <p>${nombre}</p>
          <div class="imagen-categoria">
            <img src="${ nombreImagen ? '/admin/upload/' + nombreImagen : '/build/img/default-categoria.jpg' }" alt="image-categoria">
          </div>
        </div>
        `;
      });

      $('.categorias-items').append(html);
    }
  });
}

function changeDisplay(ids){
  if(ids){
    sessionStorage.setItem('categoria-activa', JSON.stringify(ids));
    window.location.href = "catalogo.php";
  }
}

function setTriggerCategorys(id){
    setTimeout(() => {
      const father = $('.categorias-mob #categoria-' + id);
      const father2 = $('.categorias-comunes #categoria-' + id);
      father.addClass('active');
      father2.addClass('active');
    }, 1000);
}

function cambiarMantenimiento(){
  $.ajax({
    url: "/admin/cambiar-mantenimiento.php"
  }).done(function( response ) {});
}

async function redibujarImagenes(parent){
  let grandparent = $('#'+parent).parent();

  let arrayParent = parent.split('-');
  let idParent = arrayParent[2];

  await $.ajax({
    method: "POST",
    url: "../admin/obtener-imagenes-item.php",
    data: {
      id: idParent
    }
  })
  .done(function( response ) {
    let images = JSON.parse(response);

    let html = ``;

    let firstImg = images[0];

    for(let i = 0; i < images.length; i++){
      let img = images[i];

      html += `
        <div class="cont-imagen" id="imagenes-actuales-${idParent}">
            <div class="controles-index controles-imagenes">
                <button type="button" id="arriba-${img.id}-${img.indice}" class="btn-index-imagen">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-triangle" width="13" height="13" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" fill="#ffffff" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75" />
                    </svg>
                </button>
                <button type="button" id="abajo-${img.id}-${img.indice}" class="btn-index-imagen inverso">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-triangle" width="13" height="13" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" fill="#ffffff" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75" />
                    </svg>
                </button>
            </div>
            <button type="button" class="btn-eliminar-imagen" id="${img.id}">Eliminar</button>
            <img src="../admin/upload/${img.nombreImagen}" alt="imagen">
        </div>
      `;
    }

    grandparent.fadeOut(0, function () {
      grandparent.html(html);
      grandparent.fadeIn(200);
    });

    $('.btn-index-imagen').on('click', async function(){
      let button = $(this);
      let id = button.attr('id');
      let array = id.split('-');
      let parent = button.parent().parent().attr('id');
    
      let arrayParent = parent.split('-');
    
      let idParent = arrayParent[2];
    
      let direccion = array[0];
      let indice = array[2];
      id = array[1];
    
      await $.ajax({
        method: "POST",
        url: "../admin/cambiar-index-imagenes.php",
        data: {
            id: id,
            direccion: direccion,
            indice: indice,
            idItem: idParent
        }
      })
      .done(function( response ) {
        if(response === "1"){
          redibujarImagenes(parent);
        }
      });
    });

    changeUniqueImage(firstImg, idParent);
  });
}

function changeUniqueImage(img, parentId) {
  const {
    id,
    nombreImagen
  } = img;

  let newRoute = '';

  if (nombreImagen.includes('/admin/upload/')) {
    newRoute = nombreImagen;
  } else {
    newRoute = '../admin/upload/' + nombreImagen;
  }

  const imgDom = $('#unique-image-' + parentId);

  imgDom.attr('src', newRoute);
}

function tableIndexAdmin(){
  if($('.table').length){
    $('.table').DataTable().destroy()
    $('.table').DataTable({
        // columns: columnsArray,
        language: {
        "decimal": "",
        "emptyTable": "No hay información",
        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
        "infoEmpty": "Mostrando 0 a 0 de 0 entradas",
        "infoFiltered": "(Filtrado de _MAX_ registros totales)",
        "infoPostFix": "",
        "thousands": ",",
        "lengthMenu": "Mostrar _MENU_ registros",
        "loadingRecords": "Cargando...",
        "processing": "Procesando...",
        "search": "Buscar:",
        "zeroRecords": "Sin resultados encontrados",
        "paginate": {
            "first": "Primero",
            "last": "Ultimo",
            "next": "Siguiente",
            "previous": "Anterior"
        }},
        pageLength: 250
    });
  }
}

function changeDinamicImageModalIndex(img, index){
  let currentIndexDom = $('.central-imagen .flot-index').text();

  let currentIndexArray = currentIndexDom.split('/');

  $('.central-imagen .flot-index').text(index + '/' + currentIndexArray[1]);

  $('.central-imagen .img-for-item').attr('src', '../admin/upload/' + img);

  if(index === 1){
    $('.modal .btn-anterior').addClass('disabled');
  } else {
    $('.modal .btn-anterior').removeClass('disabled');
  }

  if(parseInt(index) === parseInt(currentIndexArray[1])){
    $('.modal .btn-siguiente').addClass('disabled');
  } else {
    $('.modal .btn-siguiente').removeClass('disabled');
  }
}

function openModalFullScreen(){
  //<div class="slider-imagenes slider-${item.id}">${htmlImages}</div>
  //<div class="central-imagen ${condition}" onclick="openModalFullScreen()"></div>
  let arrayImages = [];

  let imageSrc = $('.central-imagen .img-for-item').attr('src');
  let images = $('.slider-imagenes .imagen-slider');

  let index = 1;

  images.each(function(){
    arrayImages.push({
      src: $(this).attr('src'),
      index: index
    });

    index++;
  });

  let tempIndex = arrayImages.find(x => x.src === imageSrc);

  if(tempIndex !== undefined){
    tempIndex = tempIndex.index;
  } else {
    tempIndex = arrayImages.find(x => x.src === '../'+ imageSrc);

    if(tempIndex !== undefined){
      tempIndex = tempIndex.index;
    } else {
      tempIndex = 1;
      arrayImages.push({src: imageSrc, index: tempIndex});
    }
  }

  let html = `
    <div class="modal-fullscreen">
      <div class="content">
        <div class="controls-1">
          <p>${tempIndex}/${arrayImages.length}</p>
          <button class="close-fullscreen">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6.39994 18.6537L5.34619 17.5999L10.9462 11.9999L5.34619 6.39994L6.39994 5.34619L11.9999 10.9462L17.5999 5.34619L18.6537 6.39994L13.0537 11.9999L18.6537 17.5999L17.5999 18.6537L11.9999 13.0537L6.39994 18.6537Z" fill="white"/>
            </svg>
          </button>
        </div>
        <div class="controls-2">
          <button class="btn-anterior ${tempIndex === 1 ? 'disabled' : ''}">
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
              <path d="M19.344 21L27.394 12.95L25.55 11.106L15.6559 21L25.55 30.8941L27.394 29.05L19.344 21Z" fill="white"/>
            </svg>
          </button>       
          <button class="btn-siguiente ${tempIndex === arrayImages.length ? 'disabled' : ''}">
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
              <path d="M22.656 21L14.606 12.95L16.45 11.106L26.3441 21L16.45 30.8941L14.606 29.05L22.656 21Z" fill="white"/>
            </svg>
          </button>
        </div>

        <div class="cont-img">
          <img class="img-for-item" src="${imageSrc}">

          <img class="flot-im-item" src="../build/img/circ-item.png" alt="logo">
        </div>
      </div>
    </div>
  `;

  $('.modal').fadeOut(0,
    function(){
      $('body').append(html);
      $('.modal-fullscreen').fadeIn();
      $('.modal-fullscreen').css("display", "flex");
    }
  );

  $('.close-fullscreen').on('click', function(){
    $('.modal-fullscreen').fadeOut(0,
      function(){
        $('.modal-fullscreen').remove();
        $('.modal').fadeIn();
      }
    );
  });

  $('.modal-fullscreen .btn-anterior').on('click', function(){
    let newImage = arrayImages.find(x => x.index === tempIndex - 1);
    $('.modal-fullscreen .btn-anterior').removeClass('disabled');
    $('.modal-fullscreen .btn-siguiente').removeClass('disabled');

    if(newImage !== undefined){
      $('.modal-fullscreen .img-for-item').attr('src', newImage.src);
      $('.modal-fullscreen p').html(`${newImage.index}/${arrayImages.length}`);
      tempIndex = newImage.index;

      if(tempIndex === 1){
        $('.modal-fullscreen .btn-anterior').addClass('disabled');
      } else {
        $('.modal-fullscreen .btn-anterior').removeClass('disabled');
      }
    }
  });

  $('.modal-fullscreen .btn-siguiente').on('click', function(){
    let newImage = arrayImages.find(x => x.index === tempIndex + 1);
    $('.modal-fullscreen .btn-anterior').removeClass('disabled');
    $('.modal-fullscreen .btn-siguiente').removeClass('disabled');

    if(newImage !== undefined){
      $('.modal-fullscreen .img-for-item').attr('src', newImage.src);
      $('.modal-fullscreen p').html(`${newImage.index}/${arrayImages.length}`);
      tempIndex = newImage.index;

      if(tempIndex === arrayImages.length){
        $('.modal-fullscreen .btn-siguiente').addClass('disabled');
      } else {
        $('.modal-fullscreen .btn-siguiente').removeClass('disabled');
      }
    }
  });
}

function moveItems() {
  let location = window.location.href;
  if (location.includes('admin/index.php') && !location.includes('?c=all') && location.includes('?c=')) {
    $('.table tbody').sortable({
      stop: function (event, ui) {
        let order = [];

        $('.table tbody tr').each(function (index) {
          let imageData = $(this).attr('id');
          let arrayData = imageData.split('-');
          let id = arrayData[2];

          order.push(id);
        });

        $.ajax({
          method: "POST",
          url: "../admin/actualizar-index-item.php",
          data: { order: order }
        }).done(function (response) {

        });
      }
    });
  }
}
function moveColors() {
  let location = window.location.href;
  if (location.includes('admin/colores.php')) {
    $('.cont-admin-colors').sortable({
      stop: function (event, ui) {
        let order = [];

        $('.cont-admin-colors .item-listado').each(function (index) {
          let colorData = $(this).attr('id');
          let arrayData = colorData.split('-');
          let id = arrayData[1];

          order.push(id);
        });

        $.ajax({
          method: "POST",
          url: "../admin/actualizar-index-colores.php",
          data: { order: order }
        }).done(function (response) {
        });
      }
    });
  }
}
function activateFilterAdmin() {
  let color = $('#filterColor option:selected').val();

  window.location.href = `index.php?c=${color}`;
}
function moveCurrentImages() {
  let location = window.location.href;
  if (location.includes('admin/')) {
    const containers = $('.imagenes-actuales')

    containers.each((index, container) => {
      let idItem = $(container).attr('id');
      let arrayData = idItem.split('-');
      idItem = arrayData[1];
      $(container).sortable({
        stop: function (event, ui) {
          let order = [];
          let firstImg = null;

          $(container).find('.cont-imagen').each(function (index) {
            let imageData = $(this).find('img').attr('id');
            let arrayData = imageData.split('-');
            let id = arrayData[1];

            if (!firstImg) {
              firstImg = {
                nombreImagen: $(this).find('img').attr('src'),
                id: id
              };
            }

            order.push(id);
          });

          $.ajax({
            method: "POST",
            url: "../admin/actualizar-index-imagenes-2.php",
            data: { order: order }
          }).done(function (response) {
            changeUniqueImage(firstImg, idItem);
          });
        }
      });
    });
  }
}
function mouseScroll() {
  let location = window.location.href;
  if ((location.includes('admin/index.php') || location.includes('admin/moods.php') || location.includes('admin/colores.php')) && !location.includes('?c=all') && location.includes('?c=')) {
    let isMouseDown = false;
    let scrollDirection = null;
    let scrollInterval = null;

    document.addEventListener('mousedown', (event) => {
      isMouseDown = true;
      updateScrollDirection(event.clientY);
      startScrolling();
    });

    document.addEventListener('mouseup', () => {
      isMouseDown = false;
      stopScrolling();
    });

    document.addEventListener('mousemove', (event) => {
      if (isMouseDown) {
        updateScrollDirection(event.clientY);
      }
    });

    function updateScrollDirection(mouseY) {
      const upperBound = 150; // Cerca del borde superior
      const lowerBound = window.innerHeight - 150; // Cerca del borde inferior

      if (mouseY <= upperBound) {
        scrollDirection = 'up'; // Desplazarse hacia arriba
      } else if (mouseY >= lowerBound) {
        scrollDirection = 'down'; // Desplazarse hacia abajo
      } else {
        scrollDirection = null; // No desplazarse
      }
    }

    function startScrolling() {
      if (scrollInterval) return; // No iniciar un nuevo intervalo si ya está corriendo

      const scrollSpeed = 50; // Velocidad del scroll
      scrollInterval = setInterval(() => {
        if (scrollDirection === 'up') {
          window.scrollBy(0, -scrollSpeed);
        } else if (scrollDirection === 'down') {
          window.scrollBy(0, scrollSpeed);
        }
      }, 100); // Frecuencia de desplazamiento
    }

    function stopScrolling() {
      clearInterval(scrollInterval);
      scrollInterval = null;
    }
  }
}

function searchItems(){
  $('.search input').on('keyup', function(){
    let value = $(this).val();
    validateIfNotFocus();
    if(value.length > 3){
      $.ajax({
        method: "GET",
        url: "../admin/buscar-items.php?param=" + value
      }).done(function (response) {
        const data = JSON.parse(response);
        tempItemsSearch = data;

        $('.resoults').empty();

        if(data.length > 0){
          let html = '';

          for(let i = 0 ; i < data.length ; i++){
            html += `
              <div class="item-search" onclick="triggerItem(${data[i].id})">
                <img src="admin/upload/${data[i].imagenes[0].nombre}" alt="${data[i].nombre}">

                <p>${data[i].nombre}</p>
              </div>
            `;
          }

          $('.resoults').append(html);
        }
      });
    } else {
      $('.resoults').empty();
    }
  })
}

function triggerItem(id){
  $('.resoults').empty();
  let currentItem = tempItemsSearch.find(x => x.id === id.toString());
  dibujarModal(currentItem);

  if($(window).width() <= 768){
    $('.btn-menu-x').click();
  }
}

function validateIfNotFocus(){
  let interval = setInterval(() => {

    if(!$('.search input').is(':focus')){

      $('.resoults').empty();

      clearInterval(interval);
    }
  }, 1000);
}

function triggerChange(type) {
  let currentIndexText = $('.flot-index').text().split('/');
  let currentIndex = parseInt(currentIndexText[0]);

  // Reset de botones deshabilitados
  $('.modal .btn-siguiente').removeClass('disabled');
  $('.modal .btn-anterior').removeClass('disabled');

  let imagesArray = $('.slider-imagenes .imagen .imagen-slider');

  // Cambiar la imagen y actualizar el índice
  if (type === 'prev') {
    if (currentIndex > 1) {
      let currentImage = imagesArray[currentIndex - 2];
      currentImage.click();
      currentIndex--; // Actualiza el índice tras cambiar
    }
  } else if (type === 'next') {
    if (currentIndex < imagesArray.length) {
      let currentImage = imagesArray[currentIndex];
      currentImage.click();
      currentIndex++; // Actualiza el índice tras cambiar
    }
  }

  // Desactivar botones según el índice actual
  if (currentIndex <= 1) {
    $('.modal .btn-anterior').addClass('disabled');
  }
  if (currentIndex >= imagesArray.length) {
    $('.modal .btn-siguiente').addClass('disabled');
  }
}